import { z } from "zod";

const UPPERCASE_REGEX = /[A-ZÇĞİÖŞÜ]/;
const LOWERCASE_REGEX = /[a-zçğıöşü]/;
const NUMBER_REGEX = /[0-9]/;

export type PasswordComplexityMessages = {
    minLength: string;
    uppercase: string;
    lowercase: string;
    number: string;
};

export const getPasswordRequirementResults = (
    password: string,
    messages: PasswordComplexityMessages,
) => [
    {
        key: "minLength" as const,
        message: messages.minLength,
        isMet: password.length >= 8,
    },
    {
        key: "uppercase" as const,
        message: messages.uppercase,
        isMet: UPPERCASE_REGEX.test(password),
    },
    {
        key: "lowercase" as const,
        message: messages.lowercase,
        isMet: LOWERCASE_REGEX.test(password),
    },
    {
        key: "number" as const,
        message: messages.number,
        isMet: NUMBER_REGEX.test(password),
    },
];

/**
 * Same rule better-auth enforces on sign-up / reset / change. The message is a
 * parameter rather than a constant so the caller can pass the translated one —
 * this runs inside the auth route handler, where the request locale is known.
 */
export const buildPasswordComplexitySchema = (
    messages: PasswordComplexityMessages,
) =>
    z
        .string()
        .min(8, messages.minLength)
        .refine((value) => UPPERCASE_REGEX.test(value), {
            message: messages.uppercase,
        })
        .refine((value) => LOWERCASE_REGEX.test(value), {
            message: messages.lowercase,
        })
        .refine((value) => NUMBER_REGEX.test(value), {
            message: messages.number,
        });
